import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const getDocumentCheckList = createAsyncThunk(
    'documentCheck/getDocumentCheckList',
    async ({ page = 1, search = '', limit = 10, userGroup }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${API_ENDPOINT}/document-check/monitoring`,
                {
                    params: {
                        page,
                        search,
                        limit,
                        user_group: userGroup,
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: error.message }
            );
        }
    }
);

const documentCheckSlice = createSlice({
    name: 'documentCheck',
    initialState: {
        document_check: {
            data: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
            },
        },
        isLoading: false,
        error: null,
    },
    reducers: {
        resetDocumentCheck: (state) => {
            state.document_check = {
                data: [],
                pagination: {
                    current_page: 1,
                    last_page: 1,
                    per_page: 10,
                    total: 0,
                },
            };
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDocumentCheckList.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getDocumentCheckList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.document_check = {
                    data: action.payload.data || [],
                    pagination: action.payload.meta || {
                        current_page: 1,
                        last_page: 1,
                        per_page: 10,
                        total: 0,
                    },
                };
            })
            .addCase(getDocumentCheckList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload?.message || 'Terjadi kesalahan';
                state.document_check.data = [];
            });
    },
});

export const { resetDocumentCheck } = documentCheckSlice.actions;
export default documentCheckSlice.reducer;